import { autoRegisterFeature } from '@store/features/factory';

import { rulesFeature } from './store/feature';

autoRegisterFeature(rulesFeature);

// Page exports
export { AdminRulesManagementPage } from './AdminRulesManagementPage';
export { RulesManagementPage } from './RulesManagementPage';

// Store exports
export * from './store';

// Type exports
export * from './types';

// Hook exports
export * from './hooks';

// Component exports
export * from './components';
